import React from "react";
import { isSet } from "../../../Utils/CommonFunctions";
import { extractFieldValue } from "../MarkupFunctions";

// Numeric for-loop SCM tag:
// <scm:for begin="0" end="entries" step="1" var="i">...</scm:for>
// - begin, end, step: numeric (strings or numbers)
// - end can be a dynamic path resolved via extractFieldValue(dynamicVar, end)
// - if end resolves to an array, its length is used
// - loop variable (var) is exposed on dynamicVar as dynamicVar[varName]
const ScmForField = ({ attributes, elmtParams }) => {
  const { convertAndRenderElement, dynamicVar: baseDynamicVar = {}, children } = elmtParams;

  if (!attributes) return null;

  const loopVarName = isSet(attributes.var, "i");
  const beginAttr = isSet(attributes.begin, "0");
  const endAttr = attributes.end;
  const stepAttr = isSet(attributes.step, "1");

  // Parse begin / step
  let start = Number(beginAttr);
  if (!Number.isFinite(start)) {
    start = 0;
  }

  let stepVal = Number(stepAttr);
  if (!Number.isFinite(stepVal) || stepVal === 0) {
    stepVal = 1;
  }

  // Resolve end
  if (endAttr == null) {
    return null;
  }

  let endVal;
  const trimmedEnd = String(endAttr).trim();

  // Numeric literal?
  if (/^-?\d+(\.\d+)?$/.test(trimmedEnd)) {
    endVal = Number(trimmedEnd);
  } else {
    // Dynamic path: resolve from dynamicVar
    const resolved = extractFieldValue(baseDynamicVar, trimmedEnd);
    if (Array.isArray(resolved)) {
      endVal = resolved.length;
    } else if (typeof resolved === "number") {
      endVal = resolved;
    } else if (resolved && typeof resolved.length === "number") {
      // strings or array-like with length
      endVal = resolved.length;
    }
  }

  if (!Number.isFinite(endVal)) {
    return null;
  }

  const results = [];

  if (stepVal > 0) {
    for (let i = start; i < endVal; i += stepVal) {
      const nextDynamicVar = {
        ...baseDynamicVar,
        [loopVarName]: i,
      };

      results.push(
        convertAndRenderElement(children, {
          ...elmtParams,
          dynamicVar: nextDynamicVar,
        })
      );
    }
  } else {
    // Negative step: count down while i > endVal
    for (let i = start; i > endVal; i += stepVal) {
      const nextDynamicVar = {
        ...baseDynamicVar,
        [loopVarName]: i,
      };

      results.push(
        convertAndRenderElement(children, {
          ...elmtParams,
          dynamicVar: nextDynamicVar,
        })
      );
    }
  }

  return <>{results}</>;
};

export default ScmForField;

